import script from "./lf-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./lf-form.vue?vue&type=script&setup=true&lang=ts"

import "./lf-form.vue?vue&type=style&index=0&id=3e786910&scoped=true&lang=less"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e786910"]])

export default __exports__